

<img src='assets/images/logo_debomon.png' class="image_full centre">
<img src='assets/images/logo_debomon_mobile.png'  class="image_mobile centre">

<div  class="row" class="center" >
    <br><br><br><h2>Cuenta verificada!</h2>
</div>
<div class="row" class="center">
    <button nbButton  status="primary" (click)="sendTo('auth/login')">Inicia sesión</button>
</div>